import { QueryClientProvider } from '@tanstack/react-query'
import { lazy, Suspense, type PropsWithChildren } from 'react'

import { getQueryClient } from '../services/queryClient'
import { isDebugEnabled } from '../utils/debug'

/**
 * ReactQuery Devtools
 *
 * This should be excluded from the Production build, as it is only useful for debugging.
 * Irrespective of that, we lazy load it.
 *
 * @see {@link https://tanstack.com/query/latest/docs/framework/react/devtools}
 */
const ReactQueryDevtools = lazy(() =>
  import('@tanstack/react-query-devtools').then((d) => ({
    default: d.ReactQueryDevtools
  }))
)

export const ReactQueryProvider = (props: PropsWithChildren<{}>) => {
  return (
    <QueryClientProvider client={getQueryClient()}>
      {props.children}
      {isDebugEnabled(false) && (
        <Suspense fallback={null}>
          <ReactQueryDevtools initialIsOpen={false} />
        </Suspense>
      )}
    </QueryClientProvider>
  )
}
